import { useQuery, gql } from "@apollo/client";
import {
  MultiSelector,
  MultiSelectorContent,
  MultiSelectorInput,
  MultiSelectorItem,
  MultiSelectorList,
  MultiSelectorTrigger,
} from "@/components/ui/multi-selector";

const GET_PALETTES = gql`
  query GET_PALETTES {
    findManyFabricPalette {
      id
      name
    }
  }
`;

interface PaletteSelectProps {
  field: {
    value: string[];
    onChange: (value: number[]) => void;
  };
}

interface PaletteValue {
  id: string;
  name: string;
}

const PaletteSelect: React.FC<PaletteSelectProps> = ({ field }) => {
  const { data, loading, error } = useQuery(GET_PALETTES);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading palettes</div>;

  const selectedValues: PaletteValue[] = (field.value ?? [])
    .map((id) => {
      const palette = data?.findManyFabricPalette.find(
        (p: any) => p.id.toString() === id.toString()
      );
      if (!palette) return null;
      return {
        id: palette.id.toString(),
        name: palette.name,
      };
    })
    .filter((value): value is PaletteValue => value !== null);

  return (
    <MultiSelector
      values={selectedValues}
      onValuesChange={(values) => {
        field.onChange(values.map((v) => Number(v.id)));
      }}
      loop
      className="max-w-full"
    >
      <MultiSelectorTrigger>
        <MultiSelectorInput placeholder="Select palettes" />
      </MultiSelectorTrigger>
      <MultiSelectorContent>
        <MultiSelectorList>
          {data?.findManyFabricPalette.map((palette: any) => (
            <MultiSelectorItem
              key={palette.id}
              value={{
                id: palette.id.toString(),
                name: palette.name,
              }}
            >
              {palette.name}
            </MultiSelectorItem>
          ))}
        </MultiSelectorList>
      </MultiSelectorContent>
    </MultiSelector>
  );
};

export default PaletteSelect;
